import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NotificationDetailDialog } from './detail-dialog/detail.dialog';
import { DialogType, NotificationDialogService } from './notification-dialog.service';
import { NotificationOverviewDialog } from './overview-dialog/overview.dialog';
@Component({
  standalone: true,
  selector: 'notification-dialog',
  templateUrl: './notification.dialog.html',
  styleUrls: ['./notification.dialog.scss'],
  imports: [NotificationOverviewDialog, NotificationDetailDialog, AsyncPipe],
})
export class NotificationDialog implements OnInit {
  public type$ = this.notificationDialogService.dialogType$;

  public dialogType = DialogType;

  constructor(private notificationDialogService: NotificationDialogService) {}

  ngOnInit(): void {}
}
